import {
  Directive,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

@Directive({
  selector: '[appHasAccess]',
  standalone: true,
})
export class HasAccessDirective implements OnInit {
  accessKey!: string;
  constructor(
    private container: ViewContainerRef,
    private template: TemplateRef<string>,
    private authenticationService: AuthenticationService
  ) {}

  @Input()
  set appHasAccess(accessKey: string) {
    this.accessKey = accessKey;
  }

  ngOnInit(): void {
    this.checkAccess();
  }

  checkAccess(): void {
    const permissions = this.authenticationService.getUserPermission();
    const perm = permissions.find(
      (p: { slug: string }) => p.slug === this.accessKey
    );
    if (perm) {
      this.container.createEmbeddedView(this.template);
    } else {
      this.container.clear();
    }
  }
}
